import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  HostListener,
  Input,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { environment } from '../../../../environments/environment';
import { FormRenderComponent } from '../../widgets/form-render/form-render.component';
import { FormsServiceService } from '../../../api/services/forms-service.service';
import { WorkflowService } from '../../../api/services/workflow.service';
import { SseService } from '../../../api/services/sse.service';
import { CommonModule } from '@angular/common';
import { ModalRendererComponent } from '../../widgets/modal-renderer/modal-renderer.component';
import { FORM_ID } from '../../../helpers/form-id.enum';
import { IntegrationStateService } from '../../../features/admin/security-integration-hub/integration-marketplace/integration-state.service';

@Component({
  selector: 'app-integration-cards',
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ModalRendererComponent,
  ],
  templateUrl: './integration-cards.component.html',
  styleUrl: './integration-cards.component.css',
})
export class IntegrationCardsComponent {
  @Input() formGroup!: FormGroup;
  @Input() fields: any;
  @Output() loadingChange = new EventEmitter<boolean>();
  @Input() selectedCategory: any;
  showValidationError = false;
  fieldsData: any;
  endpoint = environment.api_endpoint;
  selectedOptions: any[] = [];
  loadingCards: Set<string> = new Set();
  modalTitle: string = '';
  activeModalContext: any;
  workflowData: any;
  currentRecordId: string | undefined;
  currentNodeId: any;
  currentNode: any;
  recordID: any;
  nextNodes: any;
  targetWorkflowId: any;
  targetValue: any;
  workflowId: any;
  accessToken: any;
  previousNodeId: any;
  intervalId: any;
  isLoading: boolean = false;
  @ViewChild(FormRenderComponent) FormRenderComponent!: FormRenderComponent;
  @ViewChild(ModalRendererComponent) modalRendererRef!: ModalRendererComponent;

  private searchSubscription: any;
  private allFieldsData: any[] = [];

  constructor(
    private formService: FormsServiceService,
    private workflowService: WorkflowService,
    private SseService: SseService,
    private cdr: ChangeDetectorRef,
    private integrationStateService: IntegrationStateService,
  ) {}

  ngOnInit() {
    this.getData();
    this.searchSubscription =
      this.integrationStateService.searchQuery$.subscribe((query) => {
        if (!query) {
          this.fieldsData = [...this.allFieldsData];
        } else {
          const lowerQuery = query.toLowerCase();
          this.fieldsData = this.allFieldsData.filter(
            (item) =>
              item.platformName?.toLowerCase().includes(lowerQuery) ||
              item.description?.toLowerCase().includes(lowerQuery),
          );
        }
        this.cdr.detectChanges();
      });
  }

  ngOnDestroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
    this.searchSubscription?.unsubscribe();
  }

  ngOnChanges(changes: SimpleChanges) {
    // if (changes['selectedCategory']) {
    //   this.getData();
    // }
    if (
      (changes['formGroup'] || changes['fields']) &&
      this.formGroup &&
      this.fields
    ) {
      this.getData();
    }
  }

  get control() {
    return this.formGroup.get(this.fields.fieldName);
  }

  /** Function to get the data by api or static */
  getData() {
    this.isLoading = true;
    this.loadingChange.emit(true);
    if (this.fields && this.fields.options.isStatic == true) {
      this.fieldsData = this.fields?.options?.staticOptions;
      if (this.fields?.value?.length && this.fieldsData) {
        const selectedIds = this.fields.value.map((v: any) => v.toString());

        // Only keep those that still exist in fieldsData
        const validSelections = this.fieldsData
          .map((item: any) => item._id.toString())
          .filter((id: string) => selectedIds.includes(id));

        this.control?.setValue(validSelections, { emitEvent: false });
      }

      this.restoreTagsFromSelectedOptions();
      this.isLoading = false;
      this.loadingChange.emit(false);
      //  this.fieldsData = this.fields.options.staticOptions;
    } else if (this.fields && this.fields.options.isStatic == false) {
      this.isLoading = true;
      const formId = this.fields.options.source.formID;
      const api_endpoint = this.endpoint;
      const method = this.fields.options.source.method;
      let url = this.fields.options.source.apiUrl;
      // 🚫 Skip API call for this specific URL
      // if (
      //   url ===
      //   '{{api_endpoint}}/api/v1/form/data/list/{{formID}}?category=Project Management'
      // ) {
      //   this.isLoading = false;
      //   this.loadingChange.emit(false);
      //   return;
      // }
      const replacements = {
        formID: formId,
        api_endpoint: api_endpoint,
      };
      url = this.formService.replaceTemplateTokens(url, replacements);
      const accessToken = localStorage.getItem('accessToken');
      const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`,
      };
      this.formService.loadData(method, url, headers).subscribe({
        next: (res) => {
          this.allFieldsData = res.data.records || [];
          this.fieldsData = [...this.allFieldsData];
          this.restoreTagsFromSelectedOptions();
          this.updateIntegrationState();
          this.isLoading = false;
          this.loadingChange.emit(false);
          this.cdr.detectChanges();
        },
        error: (err) => {
          this.loadingChange.emit(false);
          this.cdr.detectChanges();
        },
      });
    }
  }

  restoreTagsFromSelectedOptions() {
    if (!this.fieldsData?.length) return;

    const currentValue = (this.fields?.value || []).map((v: any) =>
      v.toString(),
    );

    const selectedOptions = this.fieldsData.filter((opt: any) =>
      currentValue.includes(opt._id?.toString()),
    );

    const restoredIds = selectedOptions.map((opt: any) => opt._id.toString());
    if (JSON.stringify(currentValue) !== JSON.stringify(restoredIds)) {
      this.control?.setValue(restoredIds, { emitEvent: false });
    }

    const selectedNames = selectedOptions.map((opt: any) => opt.name);
    this.formGroup
      .get(this.fields.fieldName + 'Tags')
      ?.setValue(selectedNames, { emitEvent: false });
  }

  private updateIntegrationState() {
    // Sidebar now fetches its own state; this is no longer needed but kept for method signature.
  }

  isSelected(option: any): boolean {
    return option.status == 'Connected';
  }

  /** Function to disable another cards  */
  isDisabled(option: any): boolean {
    if (this.fields?.fieldType !== 'singleSelect') return false;
    const value = (this.control?.value || this.fields?.value || []).map(
      (v: any) => v.toString(),
    );
    return value.length > 0 && !value.includes(option._id?.toString());
  }

  /** Function to toggle the card and push the selection into array */
  toggleSelection(option: any, type: any): void {
    const optionId = option._id?.toString();
    const optionName = option.platformName;

    const tagsControl = this.formGroup.get(this.fields.fieldName + 'Tags');

    // Use status "Connected" as selected value
    const isAlreadySelected = option.status == 'Connected';

    if (this.fields?.fieldType === 'singleSelect') {
      // =========================================================
      // ⭐ DISCONNECT HANDLING
      // =========================================================
      if (isAlreadySelected && type === 'disconnect') {
        const fieldDeps = option?.fieldDependencies || [];
        const onClickDep = fieldDeps.find(
          (dep: any) => dep.trigger === 'onClick',
        );

        // Only disconnect action block
        const disconnectBlock = onClickDep?.condition?.find(
          (block: any) => block.action === 'disconnect',
        );

        // Only modal of type "form"
        const modalCond = disconnectBlock?.conditions?.find(
          (c: any) =>
            c.type === 'modal' && c.targetType === 'form' && c.targetValue,
        );

        if (modalCond) {
          this.activeModalContext = {
            workflowId: null,
            nodeId: modalCond.targetValue,
            selectedOption: option,
            selectedName: option.platformName,
            fieldName: this.fields.fieldName,
            fieldID: optionId,
          };
          this.loadNode(modalCond.targetValue);
          const modalId = `connection_modal_${this.fields.fieldName}`;
          document.getElementById(modalId)?.classList.add('show');

          this.loadingCards.delete(optionId);
          return;
        }

        // Fallback if no disconnect modal is defined
        this.control?.setValue([]);
        tagsControl?.setValue([]);
        this.selectedOptions = [];
        this.loadingCards.delete(optionId);
        return;
      }

      // =========================================================
      // ⭐ CONNECT HANDLING
      // =========================================================
      if (type === 'connect') {
        this.loadingCards.add(optionId);

        const fieldDeps = option?.fieldDependencies || [];
        const onClickDep = fieldDeps.find(
          (dep: any) => dep.trigger === 'onClick',
        );

        // Only connect action block
        const connectBlock = onClickDep?.condition?.find(
          (block: any) => block.action === 'connect',
        );

        // Look for modal type workflow or form
        const modalCond = connectBlock?.conditions?.find(
          (c: any) =>
            c.type === 'modal' &&
            ['workflow', 'form'].includes(c.targetType) &&
            c.targetValue,
        );

        if (modalCond) {
          this.activeModalContext = {
            workflowId:
              modalCond.targetType === 'workflow'
                ? modalCond.targetValue
                : null,
            formId:
              modalCond.targetType === 'form' ? modalCond.targetValue : null,
            selectedOption: option,
            authUrl: option.integration?.authUrl,
            selectedName: option.platformName,
            fieldName: this.fields.fieldName,
            fieldID: optionId,
          };

          if (modalCond.targetType === 'workflow') {
            this.loadWorkflow(modalCond.targetValue, 0);
          }

          if (modalCond.targetType === 'form') {
            this.loadNode(modalCond.targetValue);
          }

          const modalId = `connection_modal_${this.fields.fieldName}`;
          document.getElementById(modalId)?.classList.add('show');

          this.loadingCards.delete(optionId);
          return;
        }

        // =========================================================
        // ⭐ OAUTH / Integration Handling
        // =========================================================
        if (option.integration?.authUrl) {
          let authUrl = option.integration.authUrl.replace(
            '{{base}}',
            this.endpoint,
          );

          this.accessToken = localStorage.getItem('accessToken') || '';
          const separator = authUrl.includes('?') ? '&' : '?';
          authUrl += `${separator}at=${encodeURIComponent(this.accessToken)}`;

          window.open(authUrl, '_blank');
        } else if (
          option.integration?.allowIntegration &&
          option.integration?.url
        ) {
          window.open(option.integration.url, '_blank');
        }

        // =========================================================
        // ⭐ SSE CONNECTION SUCCESS HANDLING
        // =========================================================
        const sub = this.SseService.getMessages().subscribe((msg: any) => {
          try {
            const parsed = typeof msg === 'string' ? JSON.parse(msg) : msg;

            if (
              parsed?.type === 'connectionSuccess' ||
              parsed?.type === 'connectSuccess' ||
              parsed?.payload?.status === 200
            ) {
              const newValue = [optionId];
              const newTags = [optionName];

              this.control?.setValue(newValue);
              tagsControl?.setValue(newTags);
              this.selectedOptions = [...newValue];

              this.control?.markAsTouched();
              this.control?.updateValueAndValidity();
              this.showValidationError = false;

              this.loadingCards.delete(optionId);
              sub.unsubscribe();
            }
          } catch (err) {
            console.error('Error parsing SSE message:', err);
          }
          this.cdr.detectChanges();
        });
      }
    }
  }

  /** Loads the workflow and optionally a specific node */
  loadWorkflow(wId: string, nodeId?: any, nodeIndex?: any): void {
    this.workflowData = null;

    this.workflowService.loadWorkflow(wId).subscribe({
      next: ({ workflowData, recordId }) => {
        this.workflowData = workflowData;
        this.currentRecordId = recordId;
        this.workflowId = wId;

        this.cdr.markForCheck();

        // --- Handle second last node request ---
        if (nodeIndex === 'secondLastNode') {
          const nodes = workflowData?.nodes || [];

          if (nodes.length >= 2) {
            const secondLastNode = nodes[nodes.length - 2];
            this.currentNodeId = secondLastNode._id;
            this.loadNode(secondLastNode._id, recordId);
            return;
          }
        }

        // --- Default start node logic ---
        const startNodeId = workflowData?.startNodeId;
        if (startNodeId) {
          this.currentNodeId = startNodeId;
          this.loadNode(startNodeId, recordId);
        } else {
          console.warn(`[Workflow] No startNodeId found for workflow: ${wId}`);
        }
        this.cdr.detectChanges();
      },

      error: (error: any) => {
        this.cdr.detectChanges();
      },
    });
  }

  /** Loads a node and processes navigation-related metadata */
  loadNode(nodeId: any, recordId?: string): void {
    if (this.activeModalContext?.nodeId === nodeId) {
      this.currentNodeId = nodeId;
      this.currentNode = null;
      this.nextNodes = null;
      this.targetWorkflowId = null;
      return;
    }
    const node = this.workflowData?.nodes?.find((n: any) => n._id === nodeId);
    if (!node) {
      return;
    }

    this.currentNode = node;
    this.currentNodeId = node._id;
    this.recordID = node.recordId || recordId;
    this.loadPreviousNode();
    const nextNodeIndex = this.workflowData?.nodes?.findIndex(
      (n: any) => n._id === this.currentNode?._id,
    );

    const lastNodeIndex = this.workflowData?.nodes?.length - 1;
    const isLastNode = nextNodeIndex === lastNodeIndex;
    if (this.activeModalContext) {
      this.activeModalContext.lastNode = isLastNode;
    }
    const nextButtonObj =
      node.next?.find((n: any) =>
        ['next_button', 'submit_continue'].includes(n.buttonId),
      ) || node.next?.[0];

    if (!nextButtonObj) return;

    const condition = nextButtonObj.condition;
    if (Array.isArray(condition)) {
      for (const cond of condition) {
        if (cond?.targetType === 'node' && cond?.targetValue) {
          this.nextNodes = cond.targetValue;
          return;
        }
        if (cond?.targetNodeId) {
          this.nextNodes = cond.targetNodeId;
          return;
        }
        if (cond?.targetType === 'url' && cond?.targetValue) {
          this.targetValue = cond.targetValue;
          return;
        }
        if (cond?.targetType === 'workflow' && cond?.targetValue) {
          this.targetWorkflowId = cond.targetValue;
          return;
        }
      }
    } else if (typeof condition === 'object' && condition !== null) {
      if (nextButtonObj.targetType === 'node' && nextButtonObj.targetValue) {
        this.nextNodes = nextButtonObj.targetValue;
      } else if (nextButtonObj.targetNodeId) {
        this.nextNodes = nextButtonObj.targetNodeId;
      } else if (
        nextButtonObj.targetType === 'url' &&
        nextButtonObj.targetValue
      ) {
        this.targetValue = nextButtonObj.targetValue;
      } else if (
        nextButtonObj.targetType === 'workflow' &&
        nextButtonObj.targetValue
      ) {
        this.targetWorkflowId = nextButtonObj.targetValue;
      } else {
        console.warn(`[Workflow] No valid condition in nextButtonObj.`);
      }
    } else {
      console.warn(`[Workflow] Invalid or missing condition in node.`);
    }
  }

  /** Function to validate the card is selected or not then show error message */
  validateSelection(): boolean {
    const currentValue = (this.control?.value || []).map((v: any) =>
      v.toString(),
    );

    if (currentValue.length > 0) {
      this.showValidationError = false;
      return true;
    }

    if (this.fields.isRequired) {
      this.showValidationError = true;
      return false;
    }

    this.showValidationError = false;
    return true;
  }

  openConnect(option: any, id: string) {
    const fieldDeps = option?.fieldDependencies || [];
    const onClickDep = fieldDeps.find((dep: any) => dep.trigger === 'onClick');

    if (onClickDep && Array.isArray(onClickDep.condition)) {
      for (const condBlock of onClickDep.condition) {
        const modalCond = condBlock.conditions?.find(
          (c: any) =>
            c.type === 'modal' && c.targetType === 'workflow' && c.targetValue,
        );

        if (modalCond) {
          this.activeModalContext = {
            workflowId: modalCond.targetValue,
            selectedOption: option,
            selectedName: option.platformName,
            recordID: this.recordID,
            workflowData: this.workflowData,
            authUrl: option.integration?.authUrl || null,
          };
          this.loadWorkflow(
            this.activeModalContext.workflowId,
            0,
            'secondLastNode',
          );
          const modalId = `connection_modal_${this.fields.fieldName}`;
          const modal = document.getElementById(modalId);
          if (modal) {
            modal.classList.add('show');
          }
          return;
        }
      }
    }
  }

  closeOnBackdropClick(event: MouseEvent, modalId: string) {
    const modal = document.getElementById(modalId);
    if (event.target === modal) {
      this.closeModal(modalId);
    }
  }

  closeModal(modalId: string) {
    const modal = document.getElementById(modalId);
    if (modal) modal.classList.remove('show');
    this.activeModalContext = null;
    this.stopPollingFromModalRenderer();
  }

  stopPollingFromModalRenderer() {
    if (this.modalRendererRef) {
      this.modalRendererRef.stopChildPolling();
    }
  }

  onModalFormSaved(event: any): void {
    const optionId = this.activeModalContext?.selectedOption?._id;
    const tagsControl = this.formGroup.get(this.fields.fieldName + 'Tags');

    if (event?.success) {
      const option = this.activeModalContext?.selectedOption;
      if (option && option.name) {
        console.log(`✅ Connection completed for: ${option.name}`);
      }

      const { nextNodeId, targetValue, targetWorkflowId, isSseTrigger } =
        this.resolveNavigationTargets(this.currentNode);

      const currentIndex = this.workflowData?.nodes?.findIndex(
        (n: any) => n._id === this.currentNode?._id,
      );

      const nextNodeIndex = this.workflowData?.nodes?.findIndex(
        (n: any) => n._id == nextNodeId,
      );
      const lastNodeIndex = this.workflowData?.nodes?.length - 1;

      const isLastNode = currentIndex === lastNodeIndex;
      const isNextNodeTheLastNode = nextNodeIndex === lastNodeIndex;

      const firstNodeId = this.workflowData?.nodes?.[0]?._id;

      // 🌐 Handle OAuth for first node if needed
      if (
        this.currentNode?._id === firstNodeId &&
        option?.integration?.authUrl &&
        this.activeModalContext.selectedName != 'Jira'
      ) {
        let authUrlTemplate = option.integration.authUrl;
        let authUrl = authUrlTemplate.replace('{{base}}', this.endpoint);
        this.accessToken = localStorage.getItem('accessToken') || '';
        const separator = authUrl.includes('?') ? '&' : '?';
        authUrl += `${separator}at=${encodeURIComponent(this.accessToken)}`;
        window.open(authUrl, '_blank');
      }

      // 🔥 NEW: Mark selected when NEXT NODE is the LAST node
      if (isNextNodeTheLastNode && !isLastNode) {
        const newValue = [this.activeModalContext?.selectedOption?._id];
        const newTags = [this.activeModalContext?.selectedOption?.name];

        this.control?.setValue(newValue);
        tagsControl?.setValue(newTags);

        this.currentNode.selectedOptions = newValue;
        this.workflowData.selectedOptions = newValue;

        this.control?.markAsTouched();
        this.control?.updateValueAndValidity();

        this.loadingCards.delete(optionId);
      }

      // ✅ When reaching last node (normal behavior)
      if (isLastNode) {
        const newValue = [this.activeModalContext?.selectedOption?._id];
        const newTags = [this.activeModalContext?.selectedOption?.name];

        this.control?.setValue(newValue);
        tagsControl?.setValue(newTags);
        this.selectedOptions = [...newValue];

        this.control?.markAsTouched();
        this.control?.updateValueAndValidity();

        this.loadingCards.delete(optionId);
        this.currentNode.selectedOptions = this.selectedOptions;
        this.workflowData.selectedOptions = this.selectedOptions;
        this.selectedOptions = [...newValue];
      }

      // ✅ Handle workflow transitions
      if (nextNodeId && !isSseTrigger) {
        this.loadNode(nextNodeId);
        return;
      }

      if (targetValue) {
        const token = localStorage.getItem('accessToken');
        if (token) {
          window.location.href = `${targetValue}/${token}`;
          return;
        }
      }

      if (targetWorkflowId) {
        this.loadWorkflow(targetWorkflowId);
        return;
      }

      // 🔁 SSE Trigger
      if (isSseTrigger) {
        const sseTrigger = this.currentNode?.triggers?.find(
          (trigger: any) => trigger.event === 'listenSSE',
        );
        if (sseTrigger?.config?.url && sseTrigger?.config?.nextNodeId) {
          const apiEndpoint = environment.api_endpoint;
          const authToken = localStorage.getItem('accessToken') || '';
          const resolvedUrl = sseTrigger.config.url
            .replace('{{api_endpoint}}', apiEndpoint)
            .replace('{{authToken}}', authToken);

          // this.SseService.initSSE(resolvedUrl);
          this.loadNode(sseTrigger.config.nextNodeId);
          return;
        }
      }

      // ✅ Close modal properly
      const modalId = `connection_modal_${this.fields.fieldName}`;
      const modal = document.getElementById(modalId);
      if (modal) modal.classList.remove('show');
      this.activeModalContext = null;
      // if (this.currentNode == isLastNode) {
      //   this.getData();
      // }
    }
  }

  /** Resolves navigation targets from current node */
  resolveNavigationTargets(node: any): {
    nextNodeId: string | null;
    targetValue: string | null;
    targetWorkflowId: string | null;
    recordId: string | null;
    isSseTrigger?: boolean;
  } {
    const fallback = {
      nextNodeId: null,
      targetValue: null,
      targetWorkflowId: null,
      recordId: node?.recordId ?? null,
      isSseTrigger: false,
    };

    if (!node?.next || !Array.isArray(node.next)) return fallback;

    const nextButtonObj =
      node.next.find((n: any) =>
        ['next_button', 'submit_continue'].includes(n.buttonId),
      ) || node.next[0];

    if (!nextButtonObj) return fallback;

    const resolveSseTrigger = (): {
      nextNodeId: string | null;
      isSseTrigger: boolean;
    } => {
      const sseTrigger = node.triggers?.find(
        (trigger: any) => trigger.event === 'listenSSE',
      );
      if (sseTrigger?.config?.nextNodeId) {
        return { nextNodeId: sseTrigger.config.nextNodeId, isSseTrigger: true };
      }
      return { nextNodeId: null, isSseTrigger: false };
    };

    const condition = nextButtonObj.condition;

    if (Array.isArray(condition)) {
      for (const cond of condition) {
        if (cond?.targetType === 'node' && cond?.targetValue) {
          return { ...fallback, nextNodeId: cond.targetValue };
        }
        if (cond?.targetNodeId) {
          return { ...fallback, nextNodeId: cond.targetNodeId };
        }
        if (cond?.targetType === 'url' && cond?.targetValue) {
          return { ...fallback, targetValue: cond.targetValue };
        }
        if (cond?.targetType === 'workflow' && cond?.targetValue) {
          return { ...fallback, targetWorkflowId: cond.targetValue };
        }
        if (cond?.targetType === 'manual') {
          const { nextNodeId, isSseTrigger } = resolveSseTrigger();
          if (nextNodeId) return { ...fallback, nextNodeId, isSseTrigger };
        }
      }
    } else if (typeof condition === 'object' && condition !== null) {
      if (nextButtonObj.targetType === 'node' && nextButtonObj.targetValue) {
        return { ...fallback, nextNodeId: nextButtonObj.targetValue };
      }
      if (nextButtonObj.targetNodeId) {
        return { ...fallback, nextNodeId: nextButtonObj.targetNodeId };
      }
      if (nextButtonObj.targetType === 'url' && nextButtonObj.targetValue) {
        return { ...fallback, targetValue: nextButtonObj.targetValue };
      }
      if (nextButtonObj.targetType === 'manual') {
        const { nextNodeId, isSseTrigger } = resolveSseTrigger();
        if (nextNodeId) return { ...fallback, nextNodeId, isSseTrigger };
      }
    }
    return fallback;
  }

  /** Function to set the modal title */
  setModalTitle(title: string) {
    this.modalTitle = title;
  }

  /** Loads previous node info for back navigation */
  loadPreviousNode(): void {
    const prevBtn = this.currentNode?.previous?.find(
      (p: any) => p.buttonId === 'previous_button',
    );
    if (prevBtn?.targetNodeId) {
      this.previousNodeId = prevBtn.targetNodeId;
    } else {
      console.warn('[Workflow] Previous button or targetNodeId not found.');
    }
  }

  clickedOnPrevious() {
    const currentNode = this.workflowData.nodes.find(
      (n: any) => n._id === this.currentNodeId,
    );

    if (
      currentNode &&
      currentNode.previous &&
      currentNode.previous.length > 0
    ) {
      const { targetNodeId } = currentNode.previous[0];
      if (targetNodeId) {
        this.workflowData.currentNodeId = targetNodeId;
        this.loadNode(targetNodeId);
      }
    } else {
      console.warn(
        'No previous node found for:',
        this.workflowData.currentNodeId,
      );
    }
  }

  checkPollingServiceForError(value: any) {
    const attemptNode = this.currentNode?.next?.find((next: any) =>
      next.condition.some((condGroup: any) =>
        condGroup.conditions.some((cond: any) => cond.type === 'attempts'),
      ),
    );

    if (attemptNode) {
      const targetNodeId = attemptNode?.condition?.[0]?.targetValue;
      const targetType = attemptNode?.condition?.[0]?.targetType;
      if (targetType === 'node' && targetNodeId) {
        this.loadNode(targetNodeId);
      } else if (targetType === 'workflow' && targetNodeId) {
        this.loadWorkflow(targetNodeId);
      } else {
        console.warn('⚠️ No valid target found for attempts condition');
      }
    }
  }

  trackById(index: number, item: any) {
    return item._id;
  }

  reloadData() {
    this.getData();
  }

  @HostListener('document:keydown.escape')
  onEscapeKey() {
    if (this.fields.fieldName) {
      this.closeModal('connection_modal_' + this.fields.fieldName);
    }
  }
}
